import toxicodeWelcome from 'toxilibs/toxicode_welcome.js'
import eventBus from 'toxilibs/event_bus_queued.js'
import getUrlParams from 'toxilibs/url_params.js'
import $ from 'jquery'
import globals from './globals.js'
import levelMenu from './level_menu.js'
import mailForm from './mail_form.js'
import hourOfCode from './hour_of_code.js'
import watchVirtualKeyboard from './virtual_keyboard.js'
import './level_name.js'
import './level_logs.js'
import './reset_level_save.js'

const urlParams = getUrlParams()

const fullProgressionMode = ('full' in urlParams) //FIXME && window.location.hostname === 'localhost')
const showLogMode = ('log' in urlParams)


if (window.location.hostname === 'localhost' && !fullProgressionMode) {
    let fullProgressionUrl = getUrlParams.extendUrlWithParams(window.location.href, {
        directToLevel: true,
        full: true
    })
    $('#dev_help').html(
        '<a tabindex="-1" href="' + fullProgressionUrl + '">see full</a>'
    )
}

let fromWebsite = urlParams.from
if (window.location.pathname === '/hourofcode' || window.location.pathname === '/hour_of_code.html') {
    fromWebsite = 'hourofcode'
}


const $body = $('body')
const $bodyAndHtml = $('html, body')
const $window = $(window)


const scrollDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500

let ended

eventBus.on('end', function () {
    ended = true
})




function startSoon () {
    setTimeout(eventBus.emitter('user ready to start'), 1000)
}




function showLevelMenu () {
    const afterUpdate = ended ? false : startSoon
    levelMenu.showAndUpdate(afterUpdate)
}



function init () {


    if (fromWebsite === 'hourofcode') {
        $('#left').append('<img id="hour_of_code_logo" src="img/hour_of_code_logo.png" alt="Hour Of Code" />')
    }

    mailForm.position()
    $window.on('resize', mailForm.position)

    watchVirtualKeyboard(keepCurrentAnswerVisible)

    document.addEventListener('touchstart', () => {}, {passive: true}) // iOS Safari applies :active only then

    $('#teacher').on('mousedown', function (e) {
        e.preventDefault()
    })


    if (urlParams.theme === 'basic_python') {
        $('#logo_python').fadeIn(500)
    }

    $('#logo_python').one('click', () => $('#welcome').click())


    toxicodeWelcome(startCallback, {
        images: welcomeImages(),
        outOfHeightFlux: ['#hour_of_code_welcome'],
        onLoaded: eventBus.emitter('welcome loaded')
    })


    if (globals.beneylu) {
        $('#footer').find('a').attr('href', null)
    }

}


function welcomeImages () {
    if (fromWebsite === 'hourofcode') {
        return [
            {
                id:  'teacher',
                alt: 'Silent Teacher',
                url: 'img/welcome_hour_of_code.png'
            },
            {
                id:  'hour_of_code_welcome',
                alt: 'Hour of Code',
                url: 'img/hour_of_code_logo.png',
                outOfFlux: true
            }
        ]
    } else {
        return [
            {
                id:  'teacher',
                alt: 'Silent Teacher',
                url: 'img/welcome.jpg'
            }
        ]
    }

}


function startCallback () {

    $body.addClass('started')

    if (fullProgressionMode || showLogMode) {
        $('#welcome').remove()
        eventBus.emit('user wants to see whole progression') //FIXME
        if (fullProgressionMode) {
            eventBus.emit('user wants to see all questions') //FIXME
        } else {
            eventBus.emit('user wants to see logs') //FIXME
        }
        setTimeout(() => {
            $window.scrollTop(0)
        }, 50)
    }

    if (!fullProgressionMode) {
        eventBus.emit('user wants to start')
    }
}


function handleNewChallenge () {
    const $challengesContainer = $('#challenges_container')

    // the page keeps its height while the answer retracts: scrolled to its end,
    // the browser would bring everything down until the next question comes
    eventBus.on('challenge answer given', function () {
        $challengesContainer.css('min-height', $challengesContainer.height() + 'px')
    })

    eventBus.on('challenge ended', function () {
        $('.current').removeClass('current')
    })

    if (!fullProgressionMode) {
        eventBus.on('challenge view ready', function () {
            const scrollTop = scrollTopShowingHistory($('.challenge:last-child'))
            $bodyAndHtml.stop().animate({scrollTop}, scrollDuration)
        })
    }

    eventBus.on('challenge view constructed', function (challenge) {
        $('#antichamber').append(challenge.container)
        challenge.question.display(function () {
            $challengesContainer.css('min-height', '').append(challenge.container)
            challenge.focus()
            eventBus.emit('challenge view ready', challenge)
        })
    })

}


// the question at the bottom of the screen, the history above it; a too tall question shows its top
function scrollTopShowingHistory ($challenge) {
    const {top} = $challenge.offset()
    const bottom = top + $challenge.outerHeight()
    return Math.min(top - scrollPadding('top'), bottom + scrollPadding('bottom') - visibleHeight())
}


// around the current question (see css)
function scrollPadding (side) {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-' + side)) || 0
}


// not covered by the virtual keyboard
function visibleHeight () {
    return window.visualViewport ? window.visualViewport.height : $window.height()
}


const keyboardMargin = 8

// the browsers bring the focused field above the keyboard, not always the whole answer row
function keepCurrentAnswerVisible (viewport) {
    const $answer = $('#challenges_container .challenge.current .answer')
    if ($answer.length === 0) {
        return
    }
    const visibleBottom = viewport.offsetTop + viewport.height
    const hiddenHeight = $answer[0].getBoundingClientRect().bottom + keyboardMargin - visibleBottom
    if (hiddenHeight > 0) {
        window.scrollBy(0, hiddenHeight)
    }
}


export default function () {

    if (fromWebsite === 'hourofcode') {
        hourOfCode()
    }

    handleNewChallenge()

    eventBus.on('current state loaded', init)

    eventBus.on('level won', function () {
        setTimeout(showLevelMenu, 800)
    })

}

